import React, { useState } from 'react';
import { Tab, Grid, Button, Icon, Header } from 'semantic-ui-react';
import { FieldArray, Formik } from 'formik';
import moment from 'moment';

import SingleDelivery from './SingleDelivery';

import UpdateAxios from "../../axiosComponent/update";
import cogoToast from 'cogo-toast';
import { FEATURES } from '../../../utils/constant'
import * as yup from "yup";
import { REQUIRED } from "../../../utils/validationConstant";

//Vehicle Reporting Components
import FormikStatusChange from "../modals/statusChange";
import FormikDropDetails from "../modals/deliveryModal";
import FormikPickup from "../modals/pickupModal";
import AddPod from "../modals/podModal";
import ViewPod from "../modals/viewPod";
import StatusHistory from "../modals/statusHistory";





const DeliveryDetailComponentRebuilt = ({ deliveries, t, orderDetail, getOrderDetails, activeOrder, vehicleReporting, serviceType, ...props }) => {

  const [orderEditMode, setOrderEditMode] = useState(false);
  const [podModal, setPodModal] = useState(false);
  const [deliverySD, setDeliverySD] = useState({});
  const [historyModal, setHistoryModal] = useState(false);
  const [viewPodModal, setViewPodModal] = useState(false);


  let formatProducts = (products) => {
    return products.map((o, i) => {
      return {
        "product_code": o.sku ? o.sku.product_code : null,
        "quantity": +o.quantity,
        "invoice_no": o.invoice_no,
        "product_category_id": o.product_category_id,
        "product_id": o.product_id,
        "product_name": o.product_name,
        "packaging_type_id": Number(o.packaging_type_id),
        "length": Number(o.length),
        "breadth": Number(o.breadth),
        "height": Number(o.height)
      }
    })
  }

  let formatInvoices = (invoices) => {
    return invoices.map((o, i) => {
      return {
        "invoice_id": o.id,
        "invoice_no": o.invoice_no,
        "bl_no": o.bl_no,
        "invoice_date": o.invoice_date,
        "boe_date": o.boe_date,
        "boe_no": o.boe_no,
        "invoice_quantity": +o.invoice_quantity,
        "invoice_amount": +o.invoice_amount,
        "tracking_number": o.tracking_number
      }
    })
  }

  const initialValues = {
    deliveries: deliveries
  }

  const onSubmit = (values, { onSubmitProps }) => {
    console.log("Values for Delivery Edit ", values);

    let deliveryValues = [];
    if (values.deliveries.length > 0) {
      values.deliveries.map((o, i) => {
        let temp = {}
        temp.min_temp = o.min_temp ? o.min_temp : null
        temp.max_temp = o.max_temp ? o.max_temp : null
        temp.container_no = o.container_no
        temp.consignor_code = o.consignor ? o.consignor.consignorCode : null
        temp.consignee_code = o.consignee ? o.consignee.consigneeCode : null
        temp.container_type = o.container_type
        temp.lr_no = o.lr_no
        temp.transporter_lr_no = o.transporter_lr_no
        temp.delivery_reference_no = o.delivery_reference_no
        temp.lr_date = o.lr_date
        temp.import_declaration_no = o.import_declaration_no
        temp.boarding_no = o.boarding_no
        temp.billing_party_branch_id = o.billing_party_branch_id
        temp.billing_party_id = o.billing_party_id
        temp.billing_party_branch_id = o.billing_party_branch_id
        temp.do_no = o.do_no
        temp.do_validity_date = o.do_validity_date
        temp.charged_weight = o.charged_weight
        temp.actual_weight = o.actual_weight
        temp.total_quantity = parseInt(o.total_quantity)
        temp.gross_weight = o.gross_weight
        temp.remarks = o.remarks
        temp.cha_id = o.cha_id
        temp.yard_id = o.yard_id
        temp.shipping_line_id = o.shipping_line_id
        temp.customer_type_id = o.customer_type_id
        temp.deliver_to = o.deliver_to
        temp.deliver_to_address = o.deliver_to_address
        temp.container_pickup_date = o.container_pickup_date ? moment(o.container_pickup_date).format("YYYY-MM-DD HH:mm:ss") : null
        temp.delivery_date = o.delivery_date ? moment(o.delivery_date).format("YYYY-MM-DD HH:mm:ss") : null
        temp.container_return_date = o.container_return_date ? moment(o.container_return_date).format("YYYY-MM-DD HH:mm:ss") : null
        temp.storage_expiration_date = o.storage_expiration_date ? moment(o.storage_expiration_date).format("YYYY-MM-DD HH:mm:ss") : null
        temp.demurrage_expiration_date = o.demurrage_expiration_date ? moment(o.demurrage_expiration_date).format("YYYY-MM-DD HH:mm:ss") : null
        temp.ata_date = o.ata_date ? moment(o.ata_date).format("YYYY-MM-DD HH:mm:ss") : null
        temp.products = o.products.length > 0 ? formatProducts(o.products) : []
        temp.invoices = o.invoices.length > 0 ? formatInvoices(o.invoices) : []
        deliveryValues[i] = temp

        UpdateAxios({
          patchURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${o.delivery_id}`,
          payload: { ...temp },
          uniqueId: o.delivery_id,
        })
          .then((response) => {
            if (response.data.status == 1) {
              let alert = {
                type: "success",
                messageHeader: "Success",
                messageBody: `Delivery is updated.`,
              };
              cogoToast.success(alert.messageBody);
              getOrderDetails();
              setOrderEditMode(!orderEditMode);
            }
          })
          .catch((err) => {
            console.log(err);
          });

      });
    }
  }


  //Vehicle Reporting Section
  const handleHistoryModal = (deliveries) => {
    setDeliverySD(deliveries);
    setHistoryModal(true)
  }

  const handleViewPodModal = () => {
    setViewPodModal(true)
  }

  return (
    <React.Fragment>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
      >
        {({ touched, errors, values, isSubmitting, handleSubmit }) => {
          return (
            <FieldArray
              name="deliveries"
            >
              {({ form }) => {
                const { values } = form
                const { deliveries } = values

                let panes = []
                deliveries.map((delivery, deliveryIndex) => {

                  let paneItem = {}

                  paneItem.menuItem = `Delivery ${deliveryIndex + 1}`
                  paneItem.render = () => {
                    return (
                      <Tab.Pane key={delivery.delivery_reference_no}>
                        {vehicleReporting ?
                          <Grid columns={4} className="ml-2 mt-1">
                            <Grid.Column width={4} />
                            <Grid.Column width={10}>
                              <Grid.Row style={{ float: "right", paddingRight: "2%" }}>
                                {(orderDetail.shipment.movement_type == "Import" || orderDetail.shipment.movement_type == "Importar") && FEATURES.pickupAndDropDetailsInAllocatedOrders ?
                                  <>
                                    <FormikPickup
                                      delivery_id={delivery ? delivery.delivery_id : "NA"}
                                      delivery_status={delivery ? (delivery.delivery_status ? delivery.delivery_status.delivery_code : "NA") : "NA"}
                                      delivery_text={delivery ? (delivery.delivery_status ? delivery.delivery_status.delivery_text : "NA") : "NA"}
                                      movement_type={orderDetail.shipment.movement_type}
                                      delivery_details={delivery ? delivery : "NA"}
                                    />
                                    <FormikDropDetails
                                      t={t}
                                      delivery_id={delivery ? delivery.delivery_id : "NA"}
                                      drop_location={delivery.drop_location ? delivery.drop_location : ""}
                                      delivery_status={delivery ? (delivery.delivery_status ? delivery.delivery_status.delivery_code : "NA") : "NA"}
                                      delivery_details={delivery ? delivery : "NA"}
                                    />
                                  </>
                                  :
                                  !FEATURES.disableStatusDetailsInAllocatedOrders &&
                                  <>
                                    <FormikStatusChange
                                      movement_type={orderDetail.shipment.movement_type}
                                      delivery_id={delivery ? delivery.delivery_id : "NA"}
                                      delivery_status={delivery ? (delivery.delivery_status ? delivery.delivery_status.delivery_code : "NA") : "NA"}
                                      delivery_status_id={delivery ? (delivery.delivery_status ? delivery.delivery_status.delivery_status_id : "NA") : "NA"}
                                      delivery_time={delivery ? (delivery.delivery_status ? delivery.delivery_status.status_timestamp : "NA") : "NA"}
                                    />
                                    <Button
                                      type="button"
                                      onClick={() => handleHistoryModal(delivery)}
                                      size="mini"
                                      color="blue"
                                      className="mr-2"
                                      basic
                                      icon
                                    >
                                      <Icon name="time" />
                                      &nbsp;Status History
                                    </Button>
                                    {historyModal
                                      &&
                                      (<StatusHistory
                                        {...props}
                                        delivery_id={deliverySD.delivery_id}
                                        open={historyModal}
                                        onClose={() => setHistoryModal(false)}
                                      />)
                                    }


                                  </>
                                }
                              </Grid.Row>
                            </Grid.Column>
                            {!FEATURES.disablePODDetailsInAllocatedOrders ?
                              <>
                                <Grid.Column width={2}>
                                  <Grid.Row>
                                    <Button
                                      hidden={delivery && delivery.is_delivered === 1 ? true : false}
                                      type="button"
                                      onClick={() => { setPodModal(true) }}
                                      size="mini"
                                      color="blue"
                                      className="mr-2"
                                      basic
                                      icon
                                    >
                                      <Icon name="plus" />&nbsp;PoD
                                    </Button>
                                    <Button
                                      type="button"
                                      hidden={delivery && delivery.is_delivered === 1 ? false : true}
                                      onClick={handleViewPodModal}
                                      size="mini"
                                      color="green"
                                      className="ml-2 mr-2"
                                      basic
                                      icon
                                    >
                                      <Icon name="eye" />&nbsp;PoD
                                    </Button>
                                    <AddPod {...props} delivery={delivery} deliveryDetails={deliveries} orders={orderDetail} mode="create" open={podModal} onClose={() => setPodModal(false)} />
                                    <ViewPod {...props} delivery={delivery} deliveryDetails={deliveries} viewPod={viewPodModal} orders={orderDetail} viewPodModalClose={() => setViewPodModal(false)} />
                                  </Grid.Row>
                                </Grid.Column>
                              </>
                              :
                              ""
                            }
                          </Grid>
                          :
                          ""
                        }

                        <SingleDelivery
                          delivery={delivery}
                          deliveryIndex={deliveryIndex}
                          getOrderDetails={getOrderDetails}
                          orderTruckLoadType={props.orderTruckLoadType}
                          orderDetail={orderDetail}
                          activeOrder={activeOrder}
                          handleSubmit={handleSubmit}
                          orderEditMode={orderEditMode}
                          setOrderEditMode={setOrderEditMode}
                          serviceType={serviceType}
                          t={t}
                        />
                      </Tab.Pane>
                    )
                  }

                  return panes.push(paneItem);
                })

                return (
                  <Tab panes={panes} />
                )
              }}

            </FieldArray>
          )

        }}

      </Formik>
    </React.Fragment>
  )
}

export default DeliveryDetailComponentRebuilt 